import axiosInstance from "./AxiosInstance";

export function getMedicineTypes(
  pagination,
  pageid,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return axiosInstance.post("medicine-types/list", {
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_by,
    sort_order,
  });
}

export function createMedicineType(data) {
  return axiosInstance.post("medicine-types/add", data);
}

export function updateMedicineType(data) {
  return axiosInstance.post("medicine-types/edit", {
    ...data,
  });
}

export function deleteMedicineType(medicineTypeId) {
  return axiosInstance.post("medicine-types/delete", {
    medicine_type_id: medicineTypeId,
  });
}

export function formatMedicineTypes(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((item) => ({
      ...item,
      medicine_type_id:
        item.medicine_type_id || item._id || item.id,
    }));
  }

  let list = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      list.push({
        ...responseData[key],
        medicine_type_id:
          responseData[key].medicine_type_id ||
          responseData[key]._id ||
          responseData[key].id ||
          key,
      });
    }
  }
  return list;
}
